import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../../language/vn';
import {SoVanThuService} from '../../../../service/info/service-sovanthu';
import { FormBuilder} from '@angular/forms';
import {SoVanThu} from '../../../../models/info/sovanthu';
import { ToastrService } from 'ngx-toastr';
import {BsModalService} from 'ngx-bootstrap/modal';
import {environment} from '../../../../../environments/environment';
import {EditSoVanThuComponent} from '../../sovanthu/edit.component';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {NavItemService} from '../../../../service/staff/service-navitem';

@Component({
  templateUrl: './quanlyso.component.html'

})export class SVTVanBanDenComponent implements OnInit {

  public language = language;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public dataList: SoVanThu[];
  public keyword: string = '';
  public permission: boolean = false;
  constructor( public soVanThuService: SoVanThuService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public navItemService: NavItemService


  ) {

  }
  ngOnInit(): void {
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId, '0030', true).subscribe(
      x => {
        this.permission = x >0? true: false;

      }
    );
    this.search(this.keyword);

  }


  edit(id: number) {
    if(this.permission) {
      const modalEdit = this.bsModalService.show(EditSoVanThuComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<EditSoVanThuComponent>modalEdit.content).edit(
        id
      );
      (<EditSoVanThuComponent>modalEdit.content).onClose.subscribe(result => {
        this.search(this.keyword);
      });
    }
  }
  search(keyword)
  {
    this.keyword = keyword;
    this.soVanThuService.findAllByDonViPaging(keyword, Sessioncommand.maDonVi, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.soVanThuService.getCountByDonVi(keyword, Sessioncommand.maDonVi).subscribe(recordCount => this.totalItems = recordCount);
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search(this.keyword);

  }



}
